<template>
    <share-button 
        :openShareCb="openShare"
        :color="color"
        :classes="classes"
    />
</template>

<script>
    import ShareButton from '../common/share/share-button.vue';

    export default {
        props: {
            id: String,
            url: String,
            classes: String|Array|Object,
            color: String,
        },
        components: {
            ShareButton,
        },
        methods: {
            openShare() {
                if(this.id && this.url) {
                    this.$store.commit('share/setUrl', {
                        type: 'product',
                        id: this.id,
                        url: this.url,
                        urlType: 'image',
                    });
                    this.$store.commit('share/openShareModal');
                }
            }
        },
    }
</script>
